import { useDispatch, useReduxState } from 'hooks';
import api from 'api';
import { Alert, SendEmail } from 'components/common';

import type { EmailTemplateData, UserWithBasicData } from 'shared-types';

interface Props {
  automatedReminders?: boolean;
  buttonIsDropdown?: boolean;
  emailLogType: string;
  emailTemplates: EmailTemplateData[];
  emailTemplatesDefault: EmailTemplateData;
  isCompletion: boolean;
  targetUser: UserWithBasicData;
}

const MyTeamReviewSendReminder = ({
  automatedReminders = false,
  buttonIsDropdown = false,
  emailLogType,
  emailTemplates,
  emailTemplatesDefault,
  targetUser
}: Props) => {
  const { dispatch } = useDispatch();
  const { messages } = useReduxState();

  const handleSubmit = async (values) => {
    const response = await api.post(`/admin/emails/message`, {
      emailAddresses: [targetUser.email],
      emailLogType,
      userIdsByEmail: { [targetUser.email]: targetUser.id },
      ...values.email
    });

    if (!response.data || !response.data.success) throw new Error();

    if (response.data.successfulSends) {
      dispatch.addNotice({
        text: messages.myTeamReviewSendReminderSuccess,
        type: 'success'
      });
    } else if (response.data.erroredEmailAddresses?.length) {
      dispatch.addNotice({
        text: `${messages.usersSendMessageError}: ${targetUser.email}`,
        type: 'warning'
      });
    }
  };

  if (!emailTemplatesDefault) return null;

  const buttonTooltip = !targetUser.email
    ? messages.userNoEmail
    : !buttonIsDropdown
    ? messages.myTeamReviewSendReminder
    : '';

  return (
    <SendEmail
      buttonCategory="lighter"
      buttonDisabled={!targetUser?.email}
      buttonIcon="bell"
      buttonIsDropdown={buttonIsDropdown}
      buttonSize="small"
      buttonTooltip={buttonTooltip}
      emailTemplates={emailTemplates}
      emailTemplatesDefault={emailTemplatesDefault}
      id={`send-reminder-${targetUser.id}`}
      modalTitle={messages.myTeamReviewSendReminder}
      onSubmit={handleSubmit}
      targetUser={targetUser}
      {...(buttonIsDropdown
        ? { buttonText: messages.myTeamReviewSendReminder }
        : {})}
    >
      {automatedReminders ? (
        <Alert
          style={{ marginBottom: 20 }}
          text={messages.myTeamReviewSendReminderWarning}
          type="warning-light"
        />
      ) : null}
    </SendEmail>
  );
};

export default MyTeamReviewSendReminder;
